import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  ModalBody,
  Row,
  Col,
  Label,
  ModalHeader,
  FormGroup,
  ModalFooter,
  Input
} from "reactstrap";
import styled from "styled-components";
import { AvForm } from "availity-reactstrap-validation";
import "flatpickr/dist/themes/material_blue.css";
import CustomSelect from "../../../../../../components/Common/CustomSelect";
import { showInfoMessage } from "../../../../../../helpers/utils";
import FullScreenPreview from '../../../../../../components/Common/FullScreenPreview';

const SignatureModal = props => {
  const {
    isOpen,
    toggle,
    userId,
    editData,
    permissions,
    options,
    updateBankDetails,
    bankDetails,
  } = props;

  const [signDate, setSignDate] = useState();
  const [expDate, setExpDate] = useState();
  const [signature, setSignature] = useState();
  const [showPreview, setShowPreview] = useState(false);
  const [selectedEntity, setSelectedEntity] = useState();

  useEffect(() => {
    if (editData !== null && isOpen) {
      // setSelectedEntity(editData);
      setSignature(editData.signature)
    } else {
      setSignature(null);
    }
  }, [isOpen]);

  useEffect(() => {
    document.addEventListener("click", handleSignature, true);
    return () => {
      document.removeEventListener("click", handleSignature, true);
    };
  }, []);

  const handleSignature = e => {
    const ids = [
      "signature__preview",
      "signature__preview_image",
      "signature__trash",
    ];
    const path = e.path || (e.composedPath && e.composedPath());
    if (
      path[0] === document.querySelector(`#${ids[0]}`) ||
      path[0] === document.querySelector(`#${ids[1]}`)
    ) {
      setShowPreview(!showPreview);
    } else if (path[0] === document.querySelector(`#${ids[2]}`)) {
      setSignature("remove");
    }
  };

  const setSignatureImage = file => {
    if (file !== undefined) {
      let file_type = file.name.split(".").pop();
      let file_types = ["PNG", "png"];
      if (file_types.indexOf(file_type) >= 0) {
        let image = Object.assign(file, {
          preview: URL.createObjectURL(file),
        });
        setSignature(image);
      } else {
        showInfoMessage("Unavailable format, add image with .png format!");
      }
    }
  };

  const onSubmitForm = (e, errors, params) => {
    if (Object.keys(bankDetails).length === 0) {
      return showInfoMessage("First you need to add a bank information");
    }

    // debugger
    if (errors.length === 0) {
      let data = {};
      let formData = new FormData();

      // for (let [key, value] of Object.entries(data)) {
      //   formData.append(key, value);
      // }

      if (signature === "remove") {
        formData.append("signature", "");
        props.updateBankDetails(bankDetails.id, formData, bankDetails.user);
        // updateLegalEntityProfile(
        //   legalEntityId,
        //   formData,
        //   legalEntityData,
        //   "remove"
        // );
      } else {
        signature !== undefined && formData.append("signature", signature);
        props.updateBankDetails(bankDetails.id, formData, bankDetails.user);
        // updateLegalEntityProfile(
        //   legalEntityId,
        //   formData,
        //   legalEntityData,
        //   ""
        // );
      }
    }
  };

  // const onSubmitForm = (e, errors, params) => {
  //   if (errors?.length === 0) {
  //     let currentData = {
  //       ...params,
  //       default_legal_entity: params.default_legal_entity.value,
  //     };
  //     if (Object.keys(bankDetails).length === 0) {
  //       showInfoMessage("First you need to add a bank information");
  //     } else {
  //       props.updateBankDetails(bankDetails.id, currentData, bankDetails.user);
  //       toggle();
  //     }
  //   }
  // };

  return (
    <Modal
      isOpen={isOpen}
      autoFocus={true}
      centered={true}
      toggle={toggle}
      size="sx"
    >
      <div className="modal-header">
        <h4 className="modal-title mt-0" id="myModalLabel">
          {editData !== null ? "Edit" : "Add"} signature
        </h4>
        <button
          type="button"
          onClick={toggle}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <AvForm className="needs-validation" onSubmit={onSubmitForm}>
        <ModalBody>
          <Row>
            <Col md={12}>
              <FormGroup className="mb-3">
                <Label htmlFor="">Signature:</Label>
                <Input
                  type="file"
                  className="form-control"
                  id="inputGroupFile03"
                  aria-describedby="inputGroupFileAddon03"
                  aria-label="Upload"
                  accept="image/png, image/PNG"
                  name="test"
                  onChange={event =>
                    setSignatureImage(event.target.files[0])
                  }
                />
              </FormGroup>
            </Col>
            <Col
              xl="4"
              className={` ${signature !== undefined && signature !== null && signature !== "remove"
                ? "fade-in-custom-animate"
                : "d-none"
                }`}
            >
              <FormGroup className="mb3">
                <Preview>
                  <div className={`image__block_signature `}>
                    <div
                      id="signature__preview"
                      className="image__preview_signature"
                    >
                      <img
                        id="signature__preview_image"
                        src={
                          signature?.preview
                            ? signature?.preview
                            : signature
                        }
                      />
                    </div>
                    <div className="image__delete_action">
                      <i
                        id="signature__trash"
                        className="mdi mdi-trash-can d-block font-size-18"
                      />
                    </div>
                  </div>
                </Preview>
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="pe-0">
          <Row>
            <Col>
              <div className="text-end">
                <button
                  onClick={e => {
                    e.preventDefault();
                    toggle();
                  }}
                  className="btn btn-primary save-user"
                >
                  Close
                </button>
                {permissions?.["change_bankdetailsmodel"] && (
                  <button
                    type="submit"
                    className="btn btn-success save-user ms-2"
                  >
                    Save changes
                  </button>
                )}
              </div>
            </Col>
          </Row>
        </ModalFooter>
      </AvForm>
      <FullScreenPreview
        isOpen={showPreview}
        image={signature}
        trigger={setShowPreview}
      />
    </Modal>
  );
};

const Preview = styled.div`
  display: flex;
  justify-content: space-between;

  .image__block_signature {
    display: flex;
    border: 1px solid #ced4da;
    border-radius: 3px;
    height: 64px;
    transition: 0.5s;
    width: 100%;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    appearance: none;
    border-radius: 0.25rem;

    .image__preview_signature {
      display: flex;
      justify-content: center;
      width: 100%;
      height: 63px;
      transition: 0.5s;
      border-radius: 0.25rem;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;

      img {
        -webkit-transform: translate(0%, 0%);
        transform: translate(0%, 0%) scale(0.7);
        max-width: 100%;
        max-height: 100%;
      }

      i {
        float: right;
      }
      &:hover {
        cursor: pointer;
        background: rgba(0, 0, 0, 0.1);
      }
    }

    .image__delete_action {
      display: flex;
      justify-content: center;
      width: 60px;
      height: 63px;
      vertical-align: middle;
      transition: 0.5s;
      border-left: 1px solid #ced4da;
      i {
        margin: auto;
      }

      &:hover {
        cursor: pointer;
        color: #f46a6a;
      }
    }

  .image__trash_block {
    margin: 23px 0 0 0;
    width: 38px;
    button {
      height: 37px;
    }
  }

  @media (max-width: 1200px) {
    margin: 16px 0 0 0;
  }
  }
`;

SignatureModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  editData: PropTypes.object,
  data: PropTypes.any,
  permissions: PropTypes.any,
  bankDetails: PropTypes.any,
  userId: PropTypes.string.isRequired,
  updateBankDetails: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
};

export default SignatureModal;
